import { render, staticRenderFns } from "./ItemListMemberCollectionLayout.vue?vue&type=template&id=6a5a2f19&scoped=true&"
import script from "./ItemListMemberCollectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListMemberCollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a2f19",
  null
  
)

export default component.exports